import moment from "moment";
import apiConfig from "../App.config";
import { CFP_State, PREFERREDLANGUAGEDRPDATA, PREFERREDLANGUAGEDRPDATA_FRENCH, TOKEN_KEY } from "../App.config";
export const isDoc = (fileUrl) => {
  let splitUrl = fileUrl.split("/");
  if (splitUrl[4] === "Images") {
    return false;
  } else {
    return true;
  }
};
export const fileExtension = (fileUrl) => {
  let splitUrl = fileUrl.split("/");
  splitUrl = splitUrl[5].split(".");
  return `.${splitUrl[1]}`;
};

export const date = (dateString) => {
  if (dateString) {
    return moment(dateString).toDate();
  }
};

export const BlobImageUrl = (filePath) => {
  return apiConfig.BASEURL
  + "file/downlaodFile?filePath="+filePath
  +"&authToken="+getTokenHeader().authToken;
}

export const prepareOption = (options, option_key, option_display) => {
  if (options) {
    let newOption = []
    options.forEach(element => {
      let prepareOption = {
        "value": element[option_key],
        "label": element[option_display]
      }
      newOption.push(prepareOption);
    });

    return newOption;
  }

}

//If you are using this method for you need to pass option_display as an array
export const prepareOptionMulDis = (options, option_key, option_display) => {
  if (options) {
    let newOption = []
    options.forEach(element => {
      let label = undefined;
      Array.isArray(option_display) && option_display.map((display, key) => {
        label = key === 0 ? element[display] : label + " " + element[display];
      })
      let prepareOption = {
        "value": element[option_key],
        "label": label + " - " + element[option_key]
      }
      newOption.push(prepareOption);
    });

    return newOption;
  }

}

//If you are using this method for you need to pass option_display as an array
export const prepareOptionMulDisNew = (options, option_key, option_display) => {
  if (options) {
    let newOption = []
    options.forEach(element => {
      let label = undefined;
      Array.isArray(option_display) && option_display.map((display, key) => {
        label = key === 0 ? element[display] : label + " " + element[display];
      })
      let prepareOption = {
        "value": element[option_key],
        "label": label
      }
      newOption.push(prepareOption);
    });

    return newOption;
  }

}

export const formatDate = (date, formatString) => {
  return moment(date).format(formatString);
};

export const extractFirstValueOfArray = (value) => {
  let arrayValues = null;

  if (Array.isArray(value) && value.length > 0) {
    arrayValues = value[0];
  }
  return arrayValues;
};

export const convertIntoArray = (value) => {
  let array = [];

  if (value) {
    array = [value];
  }
  return array;
};

export const convertIntoObject = (value, previousValue = {}) => {
  return { ...previousValue, value };
};

export const normalizeInput = (number) => {
  if (number > 100) {
    return "100+";
  } else {
    return number;
  }
};

export const download = (filePath) => {
  // apiConfig.BASEURL
  //  + "file/downlaodFile?filePath="+"/Uploads/Docs/1071742897_ABCUserData.77ae7648.xlsx"
  //  +"authToken="+utilities.getTokenHeader().authToken;
  const link = document.createElement("a");
  // link.href = filePath;
  link.href = apiConfig.BASEURL
  + "file/downlaodFile?filePath="+filePath
  +"&authToken="+getTokenHeader().authToken;

  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const extractFileType = (fileType) => {
  return fileType?.split(".")[1]?.toUpperCase();
};

export const validFileName = (fileName, maxLength) => {
  if (fileName && fileName.length) {
    if (fileName.length > maxLength) {
      fileName = `${fileName.slice(0, maxLength)}...`;
    }
  }
  return fileName;
};

export const convertIntoIconName = (fullName) => {
  if (fullName.length) {
    let splitName = fullName.split(" ");
    if (splitName[0]?.toUpperCase()[0] && splitName[1]?.toUpperCase()[0]) {
      return splitName[0].toUpperCase()[0] + splitName[1].toUpperCase()[0];
    } else {
      return splitName[0].toUpperCase()[0];
    }
  }
};

export const getTokenHeader = () => {
  const header = localStorage.getItem(TOKEN_KEY);

  return {
    authToken: header,
  };
};

export const setToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(CFP_State);
};

export const scrollToTop = () => {
  document.querySelector("body").scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
};

export const getInitialFileStatus = (fileStatus) => {
  return Array.isArray(fileStatus) && fileStatus.length > 0 ? fileStatus[fileStatus.length - 1].statusName : "";
}

export const contactDateTime = (date, time) => {
  if (date && time) {
    let dateTime = moment(date).set({
      hour: time.get("hour"),
      minute: time.get("minute"),
      second: 0,
      millisecond: 0,
    });

    return dateTime.toISOString(true);//dateTime.toDate();
  }
  return null;
};

export const toAPIDateFormat = (date) => {
  return date ? moment(date).format("YYYY-MM-DD HH:mm") : date
}

export const normalizeTelePhoneNumber = (value, previousValue) => {
  if (!value) return value;
  //remove any charater without alphnumeric
  const currentValue = value.replace(/[^\d]/g, "");
  const cvLength = currentValue.length;

  if (!previousValue || value.length) {
    if (cvLength < 4) {
      return currentValue;
    } else if (cvLength < 7) {
      return `(${currentValue.slice(0, 3)})-${currentValue.slice(3)}`;
    } else {
      return `(${currentValue.slice(0, 3)})-${currentValue.slice(
        3,
        6
      )}-${currentValue.slice(6, 10)}`;
    }
  }
};
